import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ParserImage from "../ParserImage";
import axios from "axios";
import { Toast } from 'primereact/toast';
import SpinnerLoading from "../SpinnerLoading";
import { useSearchParams } from "react-router-dom";

import "../assets/themify-icon/themify-icons.css";
import "../assets/simple-line-icon/simple-line-icons.css";
import "../assets/font-awesome/css/all.css";
import "../assets/elagent/style.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../assets/animate.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/main.css";
import "../assets/responsive.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "../assets/custom.css";
import "primereact/resources/themes/lara-light-cyan/theme.css"

const UpdateMySecretPage = (props) => {
    const navigate = useNavigate();
    const toast = useRef(null);
    const [selectedService, setSelectedService] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();
    
    const [isShow, setIsShow] = useState(false);
    const [formData, setFormData] = useState({});
    const token = searchParams.get("token")
        
    useEffect(() => {
        props.hideloader();
        ParserImage();
    });

    useEffect(() => {
        axios
            .post(`${global.config.backend}/api/secretvalidationrequestupdate`, {
                token: token.replaceAll(' ', '+')
            })
            .then((res) => {
                if(!res.data.status){
                    toast.current.show({ severity: 'warn', detail: 'Token Expired Lakukan request Ulang' });
                    setTimeout(() => {
                        navigate("/");
                    }, 2000)
                }else{
                    setFormData(res.data.data[0])
                }
            })
            .catch((res) => {
                console.log(res);
                toast.current.show({ severity: 'warn', detail: 'Error connect to services' });
            });
    }, [token]);

    const handleSubmit = (e) => {
        e.preventDefault();
        SpinnerLoading(true);

        axios
            .post(`${global.config.backend}/api/secretupdate`, formData)
            .then((res) => {
                SpinnerLoading(false);
                if (res.data.status) {
                    toast.current.show({ severity: 'success', detail: 'Data Berhasil di update' });
                    setTimeout(() => {
                        navigate("/mysecret")
                    }, 2000)
                } else {
                    toast.current.show({ severity: 'warn', detail: 'Gagal Update Data' });
                }
            })
            .catch((res) => {
                SpinnerLoading(false);
                console.log(res);
                toast.current.show({ severity: 'warn', detail: 'Error connect to services' });
            });
    };

    return (
        <>
            <Toast ref={toast} />
            <section style={{
                backgroundImage: 'url(https://api-gateway.sampangkab.go.id/be-kominfo/sampanganimation/api/getimage/L2Fzc2V0cy91cGxvYWQvaW1hZ2VzL2JhY2tncm91bmQvYmdzc2QzLW1pbi5wbmc=)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                filter: 'blur(5px)',
                height: '100%'
            }}></section>
            <section class="align-items-center d-flex h-100"
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '100%',
                    background: 'transparent'
                }}>
                <div class="container-fluid">
                    <div className="row justify-content-center mb-3">
                        <img height="100"
                            src="/assets/upload/images/template_image/kominfo.png"
                            alt="logo" />
                    </div>
                    <h5 className="text-center mb-4">DINAS KOMINFO</h5>
                    <div class="row justify-content-center align-items-center d-flex">
                        <div class="col-12 col-md-4 col-lg-3">
                            <div class="card-body"
                                style={{
                                    width: '100%',
                                    padding: 0
                                }}>
                                <form class="p-4 card shadow border-10" onSubmit={handleSubmit}>
                                    <p className="text-uppercase font-weight-bold h-2 text-dark  text-center" >Update Secret</p>
                                    <div class="form-group">
                                        <label className="mb-0">Nomer Hp</label>
                                        <input type="tel"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={(e) => setFormData({...formData, phone: e.target.value})}
                                            class="form-control form-control-lg" placeholder="Nomor Hp" />
                                    </div>
                                    <div class="form-group">
                                        <label className="mb-0">Layanan</label>
                                        <input type="text"
                                            name="service"
                                            value={formData.service}
                                            onChange={(e) => setFormData({ ...formData, service: e.target.value})}
                                            class="form-control form-control-lg" placeholder="Nama Layanan" />
                                    </div>
                                    <div class="form-group">
                                        <label className="mb-0">Akses</label>
                                        <input type="text"
                                            name="access"
                                            value={formData.access}
                                            onChange={(e) => setFormData({ ...formData, access: e.target.value})}
                                            class="form-control form-control-lg" placeholder="Access" />
                                    </div>
                                    <div class="form-group">
                                        <label className="mb-0">Username</label>
                                        <input type="text"
                                            name="username"
                                            value={formData.username}
                                            onChange={(e) => setFormData({ ...formData, username: e.target.value})}
                                            class="form-control form-control-lg" placeholder="Username" />
                                    </div>
                                    <div class="form-group">
                                        <label className="mb-0">Passoword</label>
                                        <div className="position-relative">
                                            <input type={isShow ? 'text' : 'password'}
                                                name="password"
                                                value={formData.password}
                                                onChange={(e) => setFormData({ ...formData, password: e.target.value})}
                                                class="form-control form-control-lg" placeholder="Passoword" />
                                            {isShow ? 
                                                <svg onClick={() => setIsShow(false)} className="position-absolute h-100" style={{alignItems: 'center', top: 0, right: '10px'}} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#677294"><path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Z" /></svg>
                                            :
                                                <svg onClick={() => setIsShow(true)} className="position-absolute h-100" style={{ alignItems: 'center', top: 0, right: '10px' }} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#677294"><path d="M792-56 624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM480-320q11 0 20.5-1t20.5-4L305-541q-3 11-4 20.5t-1 20.5q0 75 52.5 127.5T480-320Zm292 18L645-428q7-17 11-34.5t4-37.5q0-75-52.5-127.5T480-680q-20 0-37.5 4T408-664L306-766q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302ZM587-486 467-606q28-5 51.5 4.5T559-574q17 18 24.5 41.5T587-486Z" /></svg>
                                            }
                                        </div>
                                    </div>
                                    <div class="d-flex ">
                                        <button type="submit" class="btn btn-md btn-block text-white" style={{ background: 'linear-gradient(135deg,#04a,#05c,#04a,#04a,#002461)', marginTop: 0, marginRight: '5px' }}>
                                            Update
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default UpdateMySecretPage;
